/**
 * Wraps professional (get-booked) access checks for the dedicated /professional/* panel shell.
 */

import type { ReactNode } from "react";
import { ProfessionalProfileGuard } from "./ProfessionalProfileGuard";

export function ProfessionalPanelGuard({ children }: { children: ReactNode }) {
  return (
    <ProfessionalProfileGuard authReturnTo="/professional/dashboard">
      {children}
    </ProfessionalProfileGuard>
  );
}
